import axiosInstance from ".";

export const getCoursesList = ({ queryKey }) => {
  const [queries] = queryKey;
  return axiosInstance.get("/admin/courses", { params: queries });
};

export const deleteCourse = (id) => {
  return axiosInstance.delete(`/courses/${id}`);
};

export const getCourseDetails = (id) => {
  return axiosInstance.get("/admin/courses", { params: { id, include_modules: true } });
};
